export default "__VITE_ASSET__CXdRHXeS__"